import throttle from 'lodash/throttle'
import React, { useRef, useMemo, useCallback } from 'react'
import styled from 'styled-components'
import { breakpoints } from '@/styles'
import useEventListener from '@/hooks/use-event-listener'
import useIsMobile from '@/hooks/use-is-mobile'

const Wrapper = styled.div`
  overflow-y: scroll;
  flex: 1;
  min-width: 350px;
  position: relative;

  @media only screen and (max-width: ${breakpoints.ipadMiniMax}) {
    margin-bottom: ${props => (props.selectMode ? '80px' : '0px')};
    padding-bottom: ${props => (props.isUserAgent ? '96px' : 0)};
  }
`

const ChatCardsContainer = React.forwardRef(
  ({ children, onClick, onEndReached, hasChats, selectMode }, ref) => {
    const innerWrapperRef = useRef()
    const loading = useRef(false)
    const userAgentMobile = useIsMobile()

    const loadMore = useCallback(async () => {
      loading.current = true
      await onEndReached()
      loading.current = false
    }, [onEndReached])

    // commented by otavio. I dont think this is necessary anymore but keeping for now
    // useLayoutEffect(() => {
    //   if (loading.current || !hasChats || !ref.current || initialLoad.current) return
    //   load()
    //   async function load() {
    //     const sidebarHeight = ref.current.clientHeight
    //     const sidebarContentHeight = innerWrapperRef.current.clientHeight
    //     if (sidebarHeight > sidebarContentHeight) {
    //       console.log('load more from effect')
    //       await loadMore()
    //       initialLoad.current = true
    //     }
    //   }
    // }, [hasChats, loadMore])

    const onScroll = useMemo(
      () =>
        throttle(async event => {
          if (loading.current) return
          const el = event.target
          const scrollTop = el.scrollTop
          const scrollHeight = el.scrollHeight - el.clientHeight
          const ratio = scrollTop / scrollHeight
          if (ratio > 0.9) {
            loadMore()
          }
        }, 300),
      [loadMore]
    )
    useEventListener('scroll', onScroll, ref?.current)

    return (
      <Wrapper isUserAgent={userAgentMobile} onClick={onClick} ref={ref} selectMode={selectMode}>
        <div ref={innerWrapperRef}>{children}</div>
      </Wrapper>
    )
  }
)
export default ChatCardsContainer
